var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ABBADB",
    d: "M21.46 10.699v-.001L13.3 2.54A1.83 1.83 0 0 0 11.999 2a1.83 1.83 0 0 0-1.302.54l-8.154 8.153-.008.009a1.843 1.843 0 0 0 .003 2.6 1.83 1.83 0 0 0 1.279.54h.325v6.003c0 1.188.967 2.155 2.155 2.155h3.192a.586.586 0 0 0 .586-.586v-4.707c0-.542.44-.983.983-.983h1.882c.543 0 .984.44.984.983v4.707c0 .324.262.586.585.586h3.192a2.157 2.157 0 0 0 2.155-2.155v-6.004h.302a1.83 1.83 0 0 0 1.302-.539 1.844 1.844 0 0 0 0-2.603"
  })));
};
export default SvgHome;